import React from "react";
import { useLabels } from "../../../hooks/useLabels";

import { IconButton } from "../../icon-button";

import { Header } from "../header";

import { labels } from "./labels";

function PhotoInfoHeaderLeft({ onClose }: { onClose(): void }) {
	const [[informationLabel], areLabelsLoading] = useLabels([labels.information]);

	if (areLabelsLoading) return null;

	return (
		<>
			<IconButton iconName="cross" onClick={() => onClose()} />
			<span className="header-info__text">{informationLabel}</span>
		</>
	);
}

export function PhotoInfoHeader({ onClose }: { onClose(): void }) {
	return <Header left={<PhotoInfoHeaderLeft onClose={onClose} />} />;
}
